import { render, staticRenderFns } from "./CenarioCorpoDestinatario.vue?vue&type=template&id=5fafc943&scoped=true&"
import script from "./CenarioCorpoDestinatario.vue?vue&type=script&lang=js&"
export * from "./CenarioCorpoDestinatario.vue?vue&type=script&lang=js&"
import style0 from "./CenarioCorpoDestinatario.vue?vue&type=style&index=0&id=5fafc943&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fafc943",
  null
  
)

export default component.exports